<script lang="ts" setup>
import type { Color } from '@/types';
import { VIcon } from 'vuetify/components';

type AppCardTitleWithIconProps = {
    icon: string;
    iconColor?: Color;
};

const { iconColor = 'primary-20', icon } =
    defineProps<AppCardTitleWithIconProps>();
</script>

<template>
    <v-icon size="24px" :icon :color="iconColor" class="mb-1 mr-2" />
    <h3 class="d-inline-block text-primary text-title-small">
        <slot />
    </h3>
</template>
